// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-2[data-v-0b95a704]{gap:8px}.gap-4[data-v-0b95a704]{gap:16px}", ""]);
// Exports
module.exports = exports;
